import React from 'react';

interface PracticePreferencesFormState {
  defaultPracticeStartTime: string;
  defaultPracticeEndTime: string;
  defaultPracticeLocation: string;
  defaultDrillStepsPerDrill: number;
  aiUsePositionGroups: boolean;
}

interface PracticePreferencesSectionProps {
  formState: PracticePreferencesFormState;
  onInputChange: (field: keyof PracticePreferencesFormState, value: string | number) => void;
}

export const PracticePreferencesSection: React.FC<PracticePreferencesSectionProps> = ({
  formState,
  onInputChange
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div>
          <label className="form-label">
            Default Start Time
          </label>
          <input
            type="time"
            className="input"
            value={formState.defaultPracticeStartTime}
            onChange={(e) => onInputChange('defaultPracticeStartTime', e.target.value)}
          />
          <p className="text-xs text-stone mt-1">Optional: Default time when creating new practices</p>
        </div>

        <div>
          <label className="form-label">
            Default End Time
          </label>
          <input
            type="time"
            className="input"
            value={formState.defaultPracticeEndTime}
            onChange={(e) => onInputChange('defaultPracticeEndTime', e.target.value)}
          />
          <p className="text-xs text-stone mt-1">Optional: Default time when creating new practices</p>
        </div>

        <div className="md:col-span-2">
          <label className="form-label">
            Default Practice Location
          </label>
          <input
            type="text"
            className="input"
            value={formState.defaultPracticeLocation}
            onChange={(e) => onInputChange('defaultPracticeLocation', e.target.value)}
          />
          <p className="text-xs text-stone mt-1">Optional: Default location when creating new practices</p>
        </div>

        <div>
          <label className="form-label">
            Default Drill Steps Per Drill
          </label>
          <select
            className="input"
            value={formState.defaultDrillStepsPerDrill}
            onChange={(e) => onInputChange('defaultDrillStepsPerDrill', Number(e.target.value))}
          >
            {[1, 2, 3, 4, 5].map((count) => (
              <option key={count} value={count}>
                {count}
              </option>
            ))}
          </select>
          <p className="text-xs text-stone mt-1">Controls how many steps AI generates for each drill (1-5)</p>
        </div>

        <div className="md:col-span-2">
          <label className="form-label flex items-center gap-2">
            <input
              type="checkbox"
              className="h-4 w-4 rounded border-gray-300 text-primary focus:ring-primary"
              checked={formState.aiUsePositionGroups}
              onChange={(e) => onInputChange('aiUsePositionGroups', e.target.checked)}
            />
            Enable AI Position-Group Drill Generation
          </label>
          <p className="text-xs text-stone mt-1">
            Keep this enabled for most teams. Disable only for station-style or younger-team practices where all players rotate through the same activities (for example blocking stations, tackling stations, or general fundamentals) and players are learning multiple positions.
          </p>
        </div>
      </div>
  );
}; 